import { APP, WS_DATA } from './app.constants';

export const PROTOCOLS = `${APP}_protocols`;

export const WS_DATA_PROTOCOL = `${WS_DATA}/protocol`;
export const WS_DATA_PROTOCOLS = `${WS_DATA}/protocols`;